import React from "react";
import { useLocation } from "react-router-dom";
import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import { LabRecentNotification } from "../LabOverview/LabRecentNotification";

// Notifications page for labs (/lab-notifications) and pharmacies (/pharmacy-notifications);
// the list itself picks the right API for the logged-in user type
export const LabNotifications: React.FC = () => {
  const { pathname } = useLocation();
  updateMainHeader("Recent Notifications");
  breadCrumbsStore.updateBreadCrumbs([{ Notifications: pathname }]);

  return <LabRecentNotification marginTop={8} paginate />;
};

export default LabNotifications;
